import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";

function LoanViewModal({ isLoanModal, setIsLoanModal }) {
  if (!isLoanModal) {
    return null;
  }
  return (
    <div className="fixed inset-0 flex items-center justify-center  bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6   ">
        <div className="flex justify-end">
          <CancelIcon
            onClick={() => setIsLoanModal(false)}
            className="cursor-pointer text-black mb-2"
          />
        </div>{" "}
      </div>
    </div>
  );
}

export default LoanViewModal;
